(function() {
    fpService = fp.service = {
        getServiceName: function(serviceCall) {
            return this.getServiceKey(serviceCall) + 'Service';
        },
        getServiceKey: function(name) {
            var regExp = fpUtil.regExp.matchNonNameChars;
            regExp.lastIndex = 0;
            return S(name).replace(regExp, '').singular().camelize().s;
        },
        getService: function(serviceCall) {
            serviceCall = S(serviceCall).trim().s;
            if(!serviceCall) return;

            var service = this[serviceCall] || this[this.getServiceName(serviceCall)];
            if(_.isObject(service)) return service;
        },
        //helper to return proper save service call for old rest service vs new rest service
        getItemSaveCall: function(itemService, id) {
            return fpUtil.getId(id) ? itemService.update : itemService.create;
        },
        preferenceService: {
            update: function(preference, payload, options) {
                preference = _.getObject(preference);
                payload = _.getObject(payload);
                options = _.getObject(options);

                var service,
                    item,
                    promise;

                if(!options.session && fpUtil.isAuthenticated()) {
                    service = fpService.userService;
                    item = fp.user;
                    payload.id = item.id;
                    if(!_.has(options, 'ignoreErrors')) options.ignoreErrors = true;
                }
                else {
                    service = fpService.sessionService;
                    item = fp.session;
                    payload.id = item.token;
                }

                if(!options.replace) {
                    preference = fpUtil.getChanged(preference, item.preference);
                    if(_.size(preference)) {
                        var previous = $.extend({}, item.preference),
                            hasEmpty,
                            value;
                        for(var key in preference) {
                            value = preference[key];
                            if (fpUtil.isNullOrEmpty(value)) {
                                if(_.has(previous, key)) {
                                    hasEmpty = true;
                                    delete previous[key];
                                }
                                else delete preference[key];
                            }
                            else previous[key] = value;
                        }

                        //API does not handle clearing empty/null fields
                        if(hasEmpty) {
                            preference = previous;
                            options.replace = true;
                        }
                    }
                }

                if(options.replace || _.size(preference)) {
                    if(options.replace) {
                        payload.preference_replace = true;
                        _.empty(item.preference);
                    }
                    $.extend(item.preference, preference);

                    payload.preference = JSON.stringify(preference);
                    promise = service
                        .update(payload, options)
                        .then(function(resp) {
                            _.empty(item.preference);
                            return $.extend(item.preference, resp.preference);
                        });
                }
                else {
                    promise = $.Deferred().resolve(item.preference).promise();
                }

                return promise;
            }
        },
        currencyService: {
            get: function(storeId, refreshCache) {
                var locale = 'en',
                    distanceUnit;

                return fpUtil.map.load({
                        multipleKey: 'service_provider_type',
                        service: fpService.serviceProviderConfigurationService,
                        payload: {
                            service_provider_type: 'store_setting',
                            store_id: storeId || fp.store.id || fp.topStore.id
                        },
                        refresh: refreshCache
                    })
                    .then(function (resp) {
                        var currencyConfig = fpUtil.map.get('spcStoreSetting').get('currency').config;
                        $.extend(_.empty(fp.currency), {currency_iso_code: 'USD'}, currencyConfig);
                        if (currencyConfig) {
                            if(currencyConfig.country_iso_code_2) {
                                var code = currencyConfig.country_iso_code_2.toLowerCase();
                                if (!numeral.locales[code]) {
                                    locale = $.extend(true, {}, numeral.locales.en);
                                    locale.currency.symbol = currencyConfig.currency_symbol_override || currencyConfig.currency_symbol;
                                    if(currencyConfig.symbol_followed_by_space && locale.currency.symbol) {
                                        locale.currency.symbol += ' ';
                                    }

                                    //API is not sending a locale so let's use the country_iso_code_2 field instead
                                    numeral.register('locale', code, locale);
                                }
                                locale = code;
                            }
                            distanceUnit = currencyConfig.distance_unit;
                        }

                        numeral.locale(locale);
                        fp.distanceUnit = distanceUnit;

                        return resp;
                    });
            }
        },
        locationService: {
            get: function (payload, options) {
                if(this.__isGmMapsAuthorized === false) return $.when();

                payload = _.getObject(payload);
                options = _.getObject(options);

                var self = this,
                    componentRestrictions;

                if (options.countryCode) {
                    componentRestrictions = {
                        country: options.countryCode
                    };
                }

                //fp.log(payload, options, componentRestrictions);

                return fpUi.initGoogleMapApi(options.store_id || payload.store_id, options.libraries, null, options.intent)
                    .then(function () {
                        var deferred = $.Deferred(),
                            gmapsNS = fpUtil.getValueFromNamespace('google.maps', window);

                        if (!(gmapsNS && gmapsNS.places && gmapsNS.Geocoder)) {
                            return deferred.resolve();
                        }

                        var callbackKey = _.uniqueId('gm-auth-'),
                            oldGmMapAuthFailure = window.gm_authFailure;

                        self[callbackKey] = window.gm_authFailure = function () {
                            delete self[callbackKey];
                            self.__isGmMapsAuthorized = false;
                            if (_.isFunction(oldGmMapAuthFailure)) oldGmMapAuthFailure();
                            deferred.reject('Google Maps JavaScript API error: ReferrerNotAllowedMapError');
                        };

                        if (!self.__placesService) {
                            self.__placesService = new gmapsNS.places.PlacesService($('<div></div>')[0]);
                        }
                        if (!self.__autoCompleteService) {
                            self.__autoCompleteService = new gmapsNS.places.AutocompleteService();
                        }
                        if (!self.__geocoderService) {
                            self.__geocoderService = new gmapsNS.Geocoder();
                        }


                        //fp.warn('locationService.get', payload, options);

                        if (options.places) {
                            if (payload.placeId) {
                                self.__placesService.getDetails({
                                    sessionToken: self.sessionToken,
                                    placeId: payload.placeId,
                                    fields: ['address_component', 'formatted_address', 'geometry', 'place_id']
                                }, function (result, status) {
                                    var place;
                                    if (status == gmapsNS.places.PlacesServiceStatus.OK) {
                                        place = result;
                                    }

                                    deferred.resolve(place);

                                    if(new Date() < new Date('01/22/2020 16:00:00')) {
                                        fp.notifier.notify({
                                            name: 'LocationServiceWarning',
                                            message: 'LocationServiceWarning: google.maps.places.PlacesService response'
                                        }, {
                                            severity: 'warning'
                                        });
                                    }
                                });

                                //delete sessionToken as it has been used to call getDetails
                                delete self.sessionToken;
                            }
                            else {
                                if(!self.sessionToken) {
                                    clearTimeout(self.__sessionTimeout);

                                    //delete sessionToken after 2 minutes
                                    self.__sessionTimeout = _.delay(function () {
                                        delete self.sessionToken;
                                    }, 1000 * 60 * 2);

                                    self.sessionToken = new gmapsNS.places.AutocompleteSessionToken();
                                }

                                self.__autoCompleteService.getPredictions({
                                    sessionToken: self.sessionToken,
                                    input: payload.address,
                                    types: _.has(options, 'types') ? options.types : ['address'],
                                    componentRestrictions: componentRestrictions
                                }, function (results, status) {
                                    var predictions;

                                    if (status == gmapsNS.places.PlacesServiceStatus.OK) {
                                        //fp.log('options: ', options);
                                        //fp.log('results: ', results);

                                        predictions = results;
                                    }

                                    deferred.resolve(predictions);

                                    if(new Date() < new Date('01/22/2020 16:00:00')) {
                                        fp.notifier.notify({
                                            name: 'LocationServiceWarning',
                                            message: 'LocationServiceWarning: google.maps.places.AutocompleteService response'
                                        }, {
                                            severity: 'warning'
                                        });
                                    }
                                });
                            }
                        }
                        else {
                            var geocodePayload = _.omit(payload, 'store_id');
                            if (!geocodePayload.placeId) {
                                geocodePayload.componentRestrictions = componentRestrictions;
                            }

                            //fp.log('geocodePayload: ', geocodePayload);

                            self.__geocoderService.geocode(geocodePayload, function (results, status) {
                                var geocodeAddresses/*,
                                    promiseTimezone*/;
                                if (status == gmapsNS.GeocoderStatus.OK) {
                                    //fp.log('results: ', results);

                                    geocodeAddresses = [];

                                    var geocodeAddress,
                                        postalAddress,
                                        countryAddress;

                                    _.each(results, function (item) {
                                        //if(!item.geometry.bounds) return;

                                        geocodeAddresses.push(item);

                                        if (options.firstValid) {
                                            if (!postalAddress && _.indexOf(item.types, 'postal_code') >= 0) {
                                                postalAddress = item;
                                            }
                                            if (!countryAddress && _.indexOf(item.types, 'country') >= 0) {
                                                countryAddress = item;
                                            }
                                        }
                                    });

                                    if (options.firstValid) {
                                        geocodeAddress = postalAddress || countryAddress || _.first(geocodeAddresses);
                                        if (geocodeAddress) {
                                            geocodeAddresses = [geocodeAddress];
                                        }
                                    }
                                }

                                deferred.resolve(geocodeAddresses);

                                if(new Date() < new Date('01/22/2020 16:00:00')) {
                                    fp.notifier.notify({
                                        name: 'LocationServiceWarning',
                                        message: 'LocationServiceWarning: google.maps.places.Geocoder response'
                                    }, {
                                        severity: 'warning'
                                    });
                                }

                                //Google's timezone API does not allow referrer so this XHR request fails
                                //if(geocodePayload.placeId && options.includeTimezone && _.size(geocodeAddresses)) {
                                //    var geocodeAddress = geocodeAddresses[0],
                                //        location = fpUtil.getValueFromNamespace('geometry.location', geocodeAddress);
                                //    if(location) {
                                //        var now = new Date();
                                //        promiseTimezone = $.get(fpUtil.formatString(
                                //                'https://maps.googleapis.com/maps/api/timezone/json?location={0},{1}&timestamp={2}&key={3}',
                                //                location.lat(),
                                //                location.lng(),
                                //                now.getTime()/1000 + now.getTimezoneOffset() * 60,
                                //                'AIzaSyCQTnuNy9Z5je8qbptNE_u7gWE_sex7VOk' || fp.cache.googleApiKey
                                //            ))
                                //            .then(function(resp) {
                                //                if(_.has(resp, 'timeZoneName')) geocodeAddress.timezone = resp;
                                //            })
                                //    }
                                //}
                                //
                                //$.when(promiseTimezone)
                                //    .always(function() {
                                //        fp.log('geocodeAddresses', geocodeAddresses);
                                //        deferred.resolve(geocodeAddresses);
                                //    });
                            });
                        }

                        return deferred
                            .promise();
                    });
            }
        }
    };

    var apiMethods = fpConstants.apiMethods,
        RestService = fp.Class.extend({
            //creates service with camel case pattern i.e. offer_types becomes offerTypeService
            construct: function(serviceCall, config) {
                this.type = 'fp.service';
                this.serviceCall = serviceCall;
                this.config = config;

                var serviceName;
                if(_.isObject(config)) serviceName = config.serviceName;
                if(!serviceName) serviceName= fpService.getServiceName(serviceCall);
                if(fpService[serviceName]) {
                    fp.warn(fpUtil.formatString('Service "{0}" already exists.', serviceName));
                }

                fpService[serviceName] = this;
            },
            get: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options, apiMethods.GET);
                var serviceCall = this.serviceCall;

                if(options.formatForRestfulId) {
                    if(!payload.id) {
                        var error = fpUtil.formatString('ID is required when formatting for restful URL: {0}', serviceCall);

                        fp.notifier.notify({
                            name: 'ServiceGetError',
                            message: fpUtil.formatString('ServiceGetError: {0}', error)
                        }, {
                            severity: 'error',
                            metaData: {
                                'meta data': {
                                    'API Url': fpUtil.getApiUrl(serviceCall, payload, apiMethods.GET, true)
                                }
                            }
                        });

                        return $.Deferred().reject(error).promise();
                    }
                    serviceCall += fpUtil.formatString('/{0}', payload.id);
                    delete payload.id;
                }
                return this.invoke(serviceCall, payload, options, apiMethods.GET);
            },
            create: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(options.childServiceCall) {
                    serviceCall += '/' + options.childServiceCall;
                    options.disableChildServiceCall = true;
                }

                serviceCall += '/create';

                return this.invoke(serviceCall, payload, options, apiMethods.POST);
            },
            update: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(!(payload.id || options.ignoreId)) {
                    var error = 'ID is required for update item.';

                    fp.notifier.notify({
                        name: 'ServiceUpdateError',
                        message: fpUtil.formatString('ServiceUpdateError: {0}', error)
                    }, {
                        severity: 'error',
                        metaData: {
                            'meta data': {
                                'API Url': fpUtil.getApiUrl(serviceCall, payload, apiMethods.POST, true)
                            }
                        }
                    });

                    return $.Deferred().reject(error).promise();
                }

                if(payload.id && options.formatForRestfulId !== false && payload.id.indexOf(',') == -1) {
                    serviceCall += fpUtil.formatString('/{0}', payload.id);
                    delete payload.id;
                }

                if(options.childServiceCall) {
                    serviceCall += '/' + options.childServiceCall;
                    options.disableChildServiceCall = true;
                }

                serviceCall += '/update';

                return this.invoke(serviceCall, payload, options, apiMethods.POST);
            },
            delete: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(!(payload.id || options.ignoreId)) {
                    var error = 'ID is required for delete item.';

                    fp.notifier.notify({
                        name: 'ServiceDeleteError',
                        message: fpUtil.formatString('ServiceDeleteError: {0}', error)
                    }, {
                        severity: 'error',
                        metaData: {
                            'meta data': {
                                'API Url': fpUtil.getApiUrl(serviceCall, payload, apiMethods.POST, true)
                            }
                        }
                    });

                    return $.Deferred().reject(error).promise();
                }

                if(payload.id) serviceCall += fpUtil.formatString('/{0}', payload.id);

                if(options.childServiceCall) {
                    serviceCall += '/' + options.childServiceCall;
                    options.disableChildServiceCall = true;
                }
                serviceCall += '/delete';

                delete payload.id;
                return this.invoke(serviceCall, payload, options, apiMethods.POST);
            },
            post: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(payload.id) {
                    serviceCall += fpUtil.formatString('/{0}', payload.id);
                    delete payload.id;
                }
                return this.invoke(serviceCall, payload, options, apiMethods.POST);
            },
            invoke: function(serviceCall, payload, options, method) {
                options = _.getObject(options);
                _.defaults(options, {
                    method: S.getString(method, apiMethods.GET),
                    queue: false
                });
                if(options.parentServiceCall) serviceCall = options.parentServiceCall + '/' + serviceCall;
                if(options.childServiceCall && !options.disableChildServiceCall) {
                    serviceCall += '/' + options.childServiceCall;
                }

                return this.api(serviceCall, payload, options);
            },
            api: function(serviceCall, payload, options) {
                return fp.api(serviceCall, payload, options);
            },
            getServiceCall: function(service, serviceCall, payload) {
                serviceCall = S.getString(serviceCall);
                payload = _.getObject(payload);

                var method = S.getString(payload.method, apiMethods.GET).toUpperCase(),
                    returnValue;

                switch(method) {
                    case 'POST':
                        if(S(serviceCall).endsWith('/delete', true)) returnValue = service.delete;
                        else if(_.has(payload, 'id')) returnValue = service.update;
                        else returnValue = this.create;
                        break;
                    default:
                        returnValue = this.get;
                }
                return returnValue;
            },
            toString: function() {
                return this.serviceCall;
            },
            __getPayload: function(payload, options, method) {
                if(_.isString(payload)) {
                    payload = {
                        id: payload
                    };
                    
                    if (
                        !_.has(options, 'formatForRestfulId') &&
                        S(method).eq('get', true) &&
                        payload.id.indexOf(',') == -1
                    ) {
                        options.formatForRestfulId = true;
                    }
                }
                else payload = _.getObject(payload);

                var config = this.config;
                if (config) {
                    _.defaults(payload, config.defaultPayload);

                    if (
                        config.requireStore &&
                        !fpConfig.disableInitializeShopping &&
                        !_.has(payload, 'store_id')
                    ) {
                        payload.store_id = fp.store.id;
                    }
                }

                return payload;
            },
            __getOptions: function(options) {
                options = _.getObject(options);
                if(this.config) _.defaults(options, this.config.defaultOptions);

                return options;
            },
            __getServiceCall: function(serviceCall) {
                return serviceCall;
            }
        }),
        OldRestService = RestService.extend({
            create: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);

                return this.invoke(this.serviceCall, payload, options, apiMethods.POST);
            },
            update: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(!(payload.id || options.ignoreId)) {
                    var error = 'ID is required for update item.';

                    fp.notifier.notify({
                        name: 'ServiceUpdateError',
                        message: fpUtil.formatString('ServiceUpdateError: {0}', error)
                    }, {
                        severity: 'error',
                        metaData: {
                            'meta data': {
                                'API Url': fpUtil.getApiUrl(serviceCall, payload, apiMethods.PUT, true)
                            }
                        }
                    });

                    return $.Deferred().reject(error).promise();
                }
                if(payload.id) {
                    serviceCall += '/' + payload.id
                }
                delete payload.id;
                return this.invoke(serviceCall, payload, options, apiMethods.PUT);
            },
            delete: function(payload, options) {
                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);
                var serviceCall = this.serviceCall;

                if(!(payload.id || options.ignoreId)) {
                    var error = 'ID is required for delete item.';

                    fp.notifier.notify({
                        name: 'ServiceDeleteError',
                        message: fpUtil.formatString('ServiceDeleteError: {0}', error)
                    }, {
                        severity: 'error',
                        metaData: {
                            'meta data': {
                                'API Url': fpUtil.getApiUrl(serviceCall, payload, apiMethods.DELETE, true)
                            }
                        }
                    });

                    return $.Deferred().reject(error).promise();
                }
                if(payload.id) {
                    serviceCall += '/' + payload.id
                }
                delete payload.id;
                return this.invoke(serviceCall, payload, options, apiMethods.DELETE);
            },
            getServiceCall: function(service, serviceCall, options) {
                var method = _.getObject(options).method || apiMethods.GET;
                switch(method.toUpperCase()) {
                    case 'PUT':
                        return service.update;
                    case 'POST':
                        return service.create;
                    case 'DELETE':
                        return service.delete;
                    default:
                        return service.get;
                }
            }
        }),
        UserMeService = RestService.extend({
            post: function(payload, options) {
                var isSession = _.getObject(options).childServiceCall === 'sessions';
                if(isSession) {
                    payload = _.getObject(payload);
                    payload.new_session_on_login = true;
                }
                return this._super(payload, options);
            },
            api: function(serviceCall, payload, options) {
                var userId = options.userId || fp.user.id;

                if(options.apiVersion == 2 && userId) {
                    serviceCall = serviceCall
                        .replace(fpUtil.formatString('/{0}', userId), '')
                        .replace('users/me', fpUtil.formatString('users/{0}', userId));
                }

                return this._super(serviceCall, payload, options);
            },
            applyAddress: function() {
                let promise;
                if(fp.user.id && !fp.user.address) {
                    promise = fpService.userAddressService
                        .get({
                            is_primary: true
                        }, {
                            handleErrors: false
                        })
                        .then(function (resp) {
                            fp.user.address = _.first(resp.items);
                        });
                }
                return $.when(promise);
            }
        }),
        ApplyProductService = RestService.extend({
            get: function(payload, options) {
                var promise = this._super(payload, options);
                if (!options.enableProducts) return promise;

                return promise
                    .then(function (resp) {
                        return fpService.productService
                            .applyToItems(resp.items, null, {
                                productIdField: options.productIdField,
                                productValueField: options.productValueField,
                                cleanUndefinedProducts: options.cleanUndefinedProducts,
                                productFields: options.productFields
                            })
                            .then(function () {
                                return resp;
                            });
                    });
            }
        }),
        ProductService = RestService.extend({
            applyToItems: function(items, payload, options) {
                if(!_.isArray(items)) return $.Deferred().resolve(items).promise();
                options = _.getObject(options);

                var productIds = '',
                    hashedItems = {},
                    productIdField = options.productIdField || 'product_id',
                    productValueField = options.productValueField || 'product',
                    productFields = options.productFields || fp.productFields,
                    productIdArray;

                _.each(items, function (item) {
                    productIdArray = item[productIdField];
                    if(productIdArray) {
                        if (!_.isArray(productIdArray)) productIdArray = [productIdArray];

                        _.each(productIdArray, function (productId) {
                            if (hashedItems[productId]) return;

                            hashedItems[productId] = true;
                            if (productIds) productIds += ',';
                            productIds += productId;
                        });
                    }
                });

                if(!productIds) {
                    if(options.cleanUndefinedProducts) {
                        _.empty(items);
                    }
                    return $.Deferred().resolve(items).promise();
                }

                return this
                    .get($.extend(payload, {
                        id: productIds,
                        fields: productFields
                    }), options)
                    .then(function (resp) {
                        if(_.size(resp.items)) {
                            var hashedProducts = _.indexBy(resp.items, 'id'),
                                isArray,
                                product,
                                products,
                                item;

                            for(var n=0; n<items.length; n++) {
                                item = items[n];
                                productIdArray = item[productIdField];
                                if(productIdArray) {
                                    products = [];
                                    isArray = _.isArray(productIdArray);
                                    if (!isArray) productIdArray = [productIdArray];

                                    _.each(productIdArray, function (productId) {
                                        product = hashedProducts[productId];
                                        if(product) products.push(product);
                                    });
                                    if(_.size(products)) {
                                        item[productValueField] = isArray ? products : _.first(products);
                                    }
                                    else if(options.cleanUndefinedProducts) {
                                        items.splice(n, 1);
                                        n--;
                                    }
                                }
                            }
                        }
                        else if(options.cleanUndefinedProducts) {
                            _.empty(items);
                        }

                        return items;
                    });
            },
            get: function(payload, options) {
                var limit = payload && payload.limit;

                if(fpConfig.enableHasProducts && !fp.store.has_products && limit !== 0) {
                    return $.Deferred().resolve({}).promise();
                }

                //return both available and no_movement products for bots
                if(fp.isBot && !(options && options.parentServiceCall && options.childServiceCall)) {
                    payload.status_id = '1,3';
                }

                return this._super(payload, options);
            }
        }),
        AdService = RestService.extend({
            construct: function (serviceCall, config) {
                config.defaultOptions = _.defaults(config.defaultOptions, {
                    enableRenderId: true,
                    handleErrors: false
                });

                this.queue = {
                    add: function (promise, priority) {
                        if (!fpUtil.isPromise(promise)) return;

                        var self = this,
                            item = {
                                promise: promise,
                                priority: fpUtil.getFloat(priority, fpConstants.priority.MINOR)
                            };

                        this.items.push(item);

                        promise
                            .always(function () {
                                _.remove(self.items, item);
                            });
                    },
                    items: []
                };

                return this._super(serviceCall, config);
            },
            get: function (payload, options) {
                if (!fpUtil.map.get('spcAdNetwork').get(this.config.adNetworkIdentifier).id) {
                    return $.Deferred()
                        .resolve({})
                        .promise();
                }

                var self = this,
                    _super = this._super,
                    promises = [],
                    priorityTrivial = fpConstants.priority.TRIVIAL,
                    priority = fpUtil.getFloat(options && options.priority, priorityTrivial);

                _.each(this.queue.items, function(item) {
                    if(priority <= item.priority) return;
                    promises.push(item.promise);
                });

                var promise = $.when.apply($, promises)
                    .then(function() {
                        return _super.call(self, payload, options);
                    });

                //if(this.config.triggerTrackUrl) {
                //    debugger;
                //    promise = promise
                //        .then(function (resp) {
                //            if(resp.track_url && _.size(resp.items)) {
                //                if (fp.isDev()) fp.log(fpUtil.formatString('{0} track Url: {1}', self.config.adNetworkIdentifier, resp.track_url));
                //                else fpUi.preloadImage(resp.track_url);
                //            }
                //            return resp;
                //        });
                //}

                return promise;
            }
        }),
        ProductAdService = RestService.extend({
            construct: function(serviceCall, config) {
                this.queue = {
                    add: function(promise, priority) {
                        if(!fpUtil.isPromise(promise)) return;

                        var self = this,
                            item = {
                                promise: promise,
                                priority: fpUtil.getFloat(priority, fpConstants.priority.MINOR)
                            };

                        this.items.push(item);

                        promise
                            .always(function() {
                                _.remove(self.items, item);
                            });
                    },
                    items: []
                };

                return this._super(serviceCall, config);
            },
            get: function(payload, options) {
                if(!fpUtil.map.get('spcAdNetwork').items().length) {
                    return $.Deferred()
                        .resolve({})
                        .promise();
                }

                options = this.__getOptions(options);
                payload = this.__getPayload(payload, options);

                if(!_.has(options, 'handleErrors')) options.handleErrors = false;

                if(options.enableRenderId && !_.has(payload, 'render_id')) {
                    payload.render_id = fp.productAdRenderId || fp.renderId;
                }

                //payload.spill = true;
                //payload.status_code = 500;
                //payload.hang_for = 3;
                //options.timeout = 2000;

                var self = this,
                    _super = this._super,
                    promises = [],
                    priorityTrivial = fpConstants.priority.TRIVIAL;

                _.each(this.queue.items, function(item) {
                    if(fpUtil.getFloat(options.priority, priorityTrivial) <= item.priority) {
                        return;
                    }

                    promises.push(item.promise);
                });

                return $.when.apply($, promises)
                    .then(function() {
                        //fp.log('productAdService', payload);

                        return _super.call(self, payload, options)
                            .then(function(resp) {
                                var productIds = [],
                                    hashedOwnProducts = {},
                                    hashedAllItems = {},
                                    items = resp.items,
                                    limit = payload.limit,
                                    item;

                                if(resp.label) scope.title = resp.label;

                                for(var n=0; n<_.size(items); n++) {
                                    item = items[n];
                                    if(item.product_id) {
                                        hashedOwnProducts[item.product_id] = item;
                                        hashedAllItems[item.product_id] = 1;
                                        productIds.push(item.product_id);
                                    }

                                    if(limit && items.length < limit) {
                                        //populate items array with child items up to limit
                                        _.find(item.products, function (wrapper) {
                                            if (wrapper.product_id && !hashedAllItems[wrapper.product_id]) {
                                                hashedAllItems[wrapper.product_id] = 1;
                                                wrapper.products = item.products;
                                                items.push(wrapper);
                                            }

                                            return items.length >= limit;
                                        });
                                    }
                                }

                                //fp.log(limit, items);

                                if(!_.size(productIds)) {
                                    delete resp.items;
                                    return resp;
                                }

                                var hasClippableOffer = payload.has_clippable_offer,
                                    hashedOffers = {},
                                    offerId;

                                return fpService.productService
                                    .get({
                                        id: _.join(productIds, {unique: true}),
                                        fields: fp.productFields
                                    }, {
                                        timeout: options.timeout,
                                        handleErrors: options.handleErrors
                                    })
                                    .then(function (childResp) {
                                        var count = 0;

                                        if(_.size(childResp.items)) {
                                            _.each(childResp.items, function (product) {
                                                item = hashedOwnProducts[product.id];
                                                item.product = product;

                                                if(hasClippableOffer) {
                                                    offerId = product.clippable_offer && product.clippable_offer.id;
                                                    if (offerId && !hashedOffers[offerId]) {
                                                        hashedOffers[offerId] = 1;
                                                    }
                                                    else return;
                                                }

                                                item.product = product;
                                                count++;
                                            });

                                            //self.triggerTrackUrls(resp);
                                        }

                                        if(!count) {
                                            delete resp.items;
                                            resp.total = 0;
                                        }

                                        return resp;
                                    });
                            });
                    });
            }
        }),
        BannerAdService = AdService.extend(),
        MultiplexService = RestService.extend({
            run: function(id, options, handleErrors) {
                options = _.getObject(options);
                if(!((fpConfig.enableMultiplex || options.enableMultiplex) && id)) return $.when();

                var fromMultiplexQueue = !_.isArray(id),
                    items = fromMultiplexQueue ? fp.multiplexQueue[id] : id,
                    method = S(fpUi.router.routeManager.urlParams.multiplex || options.method),
                    promise;

                if(_.size(items)) {
                    var payload = {
                            p: ''
                        },
                        payloadString = '',
                        apiOptions = {},
                        requirePost,
                        url;

                    if(fromMultiplexQueue) {
                        apiOptions.multiplexId = id;
                        apiOptions.runMultiplex = true;
                        apiOptions.handleErrors = handleErrors;
                    }
                    else {
                        apiOptions.prepareJsonData = false;
                        $.extend(apiOptions, options);
                    }

                    _.each(items, function (item, index) {
                        index = index.toString();
                        payload.p += (payload.p ? ',' : '') + index;

                        if(fromMultiplexQueue) {
                            item.key = index;
                            url = item.options.url;

                            if (item.options.method == apiMethods.POST) {
                                payload[index + '~m'] = item.options.method;
                                requirePost = true;
                            }
                            else if (!requirePost) payloadString += url;

                            _.each(item.options.data, function (value, key) {
                                if (key != 'app_key' && key != 'token') {
                                    payload[index + '~' + key] = value;
                                    if (!requirePost) payloadString += value;
                                }
                            });
                        }
                        else {
                            url = S(item).trimLeft(fp.apiBaseUrl).s;
                            payloadString += url;
                        }

                        payload[index + '~u'] = url;
                    });

                    //GET requests have a max limit of 2,088 characters
                    if(requirePost || payloadString.length > 2000) {
                        method = S(apiMethods.POST);
                    }
                    else if(method.ne(apiMethods.GET, true) && method.ne(apiMethods.POST, true)) {
                        method = S(apiMethods.GET);
                    }

                    promise = this[method.toLowerCase().s](payload, apiOptions);
                }

                return $.when(promise);
            }
        }),
        StoreConfigurationService = RestService.extend({
            getAssetKey: function(topStoreId) {
                return fpService.appService
                    .get({
                        store_id: topStoreId,
                        store_id_rollup: true,
                        token: null
                    }, {
                        handleErrors: false
                    })
                    .then(function(resp) {
                        var app;

                        if(_.size(resp.items)) {
                            var stores = fp.cache.hashedAuthorizedStores,
                                store = stores && stores[topStoreId],
                                lineage = store && store.lineage;

                            if(_.size(lineage)) {
                                var storeGroups = _.groupBy(resp.items, 'store_id'),
                                    storeId;

                                for(var n=lineage.length-1; n>=0; n--) {
                                    storeId = lineage[n];

                                    if(storeId != fpConfig.globalStoreId) {
                                        app = _.find(storeGroups[storeId], function (item) {
                                            return _.size(item.asset_key) && !S(item.asset_key).endsWith('_mobile');
                                        });
                                    }

                                    if(app) break;
                                }
                            }
                        }

                        return S.getString(app && app.asset_key);
                    });
            },
            getMobileWebAppKey: function() {
                return fpService.appKeyService
                    .get({
                        key: fpUtil.formatString('{0}_mobile_web', fp.appKey),
                        token: null
                    }, {
                        handleErrors: false
                    })
                    .then(function(resp) {
                        return (_.size(resp.items) && _.first(resp.items).key) || undefined;
                    });
            },
            getByAssetKey: function(payload, options) {
                var assetKey;
                if(_.isString(payload)) assetKey = payload;
                payload = _.getObject(payload);
                if(!assetKey) assetKey = fp.assetAppKey;

                return this.get(_.defaults(payload, {
                        asset_app_key: assetKey
                    }),
                    _.defaults(options, {
                        assetBaseUrl: fp.assetBaseUrl,
                        apiKey: 'sdk',
                        handleErrors: false
                    })
                );
            },
            getByTopStore: function(topStoreId) {
                var self = this;
                return this.getAssetKey(topStoreId)
                    .then(function(resp) {
                        return resp ? self.getByAssetKey(resp) : {};
                    });
            }
        });

    _.each([
        'sessions',
        'users',
        'user_addresses',
        'user_store_cards',
        'user_subscriptions',
        'subscription_lists',
        'phone',
        'circular_spots',
        'notes',
        'webhook'
    ], function(value) {
        new RestService(value, {
            defaultOptions: {
                apiVersion: 2
            }
        });
    });

    _.each([
        'shopping_lists',
        'shopping_list_items'
    ], function(value) {
        new RestService(value, {
            defaultOptions: {
                apiVersion: 2,
                enableListLoading: true,
                enableRenderId: true
            }
        });
    });

    _.each([
        'orders',
        'order_items'
    ], function(value) {
        new RestService(value, {
            defaultOptions: {
                apiVersion: 2,
                enableListLoading: true
            }
        });
    });

    _.each([
        //types, modes, statuses, etc
        'fulfillment_types',
        'tag_types',
        'user_statuses',
        'store_modes',
        'store_price_modes',
        'order_statuses',
        'order_item_statuses',
        'order_payment_statuses',
        'order_payment_types',
        'order_cancellation_reasons',
        'order_item_cancellation_reasons',
        'order_slots',
        'order_shipments',
        'order_events',
        'bagging_types',
        'user_titles',
        'substitution_types',
        'sale_configuration_types',
        'payment_statuses',
        'payment_types',
        'product_statuses',
        'product_group_statuses',
        'recipe_difficulty_levels',
        'recipe_categories',
        'recipe_statuses',
        'recipe_filters',
        'offer_statuses',
        'delivery_area_types',

        //store
        'stores',
        'store_cards',
        'store_slots',

        //tag
        'tags',

        'promotions',
        'delivery_areas',
        'timezones',
        'drop_off_locations',

        //regions
        'countries',
        'regions',

        //receipts
        'receipts',
        'receipt_items',
        'in_store_orders',

        //user
        'user_custom_attributes',
        'user_subscription_statuses',
        'user_product_subscriptions',
        'user_authentications',
        'user_terms_and_condition',
        'terms_and_condition',

        'offers',
        'circulars',
        'circular_pages',
        'service_providers',
        'service_provider_configurations',

        //product
        'product_search_suggestions',

        //departments
        'departments',

        //apps
        'app_keys',
        'sub_apps',

        //misc
        'metrics',
        'rewards',
        'reviews',
        'search_redirects',
        'urls',

        //bag tag
        'bag_tag_types',
        'bag_tags',

        'chats'
    ], function(key) {
        new RestService(key);
    });

    _.each([
        'user_product_buys',
        'user_product_upsell'
    ], function(key) {
        new ApplyProductService(key, {
            defaultOptions: {
                timeout: 10000,
                handleErrors: false
            }            
        });
    });

    new ProductService('products', {defaultOptions: {enableRenderId: true}});

    new RestService('shelf_tags', {defaultPayload: {sort: 'name'}});
    new RestService('user_event_tracking', {defaultOptions: {ignoreErrors: true}});

    //user
    //user_products and user_recipes still need v1 until this ticket is complete https://bitbucket.org/delaneyrim/freshop/issues/7721/user-products-return-not-consistent
    new OldRestService('user_products', {defaultOptions: {ignoreErrors: true}});
    new OldRestService('user_recipes', {defaultOptions: {ignoreErrors: true}});

    new UserMeService('users/me', {serviceName: 'userMeService', defaultOptions: {apiVersion: 2, ignoreId: true}});
    new StoreConfigurationService('stores/configuration', {serviceName: 'storeConfigurationService'});

    //User External Account
    new RestService('user_external_account', {serviceName: 'userExternalAccount'});

    //recipe
    new RestService('recipes', {requireStore: true});
    new RestService('recipe_items', {requireStore: true});

    //order status
    new RestService('store/order_statuses', {serviceName: 'storeOrderStatus'});

    //sponsored ad
    new ProductAdService('products/ads', {
        serviceName: 'productAdService',
        defaultOptions: {
            enableRenderId: true
        }
    });

    //banner ad
    new BannerAdService('banners/ads', {
        serviceName: 'bannerAdService',
        adNetworkIdentifier: 'ad_manager'/*,
        triggerTrackUrl: true*/
    });

    new MultiplexService('multiplex', {requireStore: true});

    new RestService('version', {
        serviceName: 'assetVersionService',
        defaultOptions: {
            assetBaseUrl: fp.assetBaseUrl,
            apiVersion: null,
            apiKey: 'sdk'
        }
    });

    fpService.constructors = {
        RestService: RestService,
        OldRestService: OldRestService
    };
})();